import { Notification as MantineNotification } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import classes from './Notification.module.css'

export const Notification = () => {
  return (
    <div className='position-fixed top-0 end-0 p-3' style={{ zIndex: 100 }}>
      <MantineNotification radius='md' classNames={classes} />
    </div>
  )
}

export const showNotification = ({
  title = '',
  message,
  type,
  duration = 5000,
}: {
  title?: string
  message: string
  type: 'success' | 'error' | 'warning' | 'info'
  duration?: number
}) => {
  notifications.show({
    title,
    message,
    color:
      type === 'success'
        ? 'green'
        : type === 'error'
          ? 'red'
          : type === 'warning'
            ? 'yellow'
            : 'blue',
    position: 'top-right',
    classNames: classes,
    autoClose: duration,
  })
}
